import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const stellareldConfig: TSPConfig = {
  key: 'stellareld',
  name: 'Stellar ELD',
  imageName: 'StellarELD',
  category: TSPCategory.API_KEY,
  helpText:
    'Please request an API Key from Stellar ELD support. Then input it here.',
  loginComponent: (props) => (
    <LoginCreds
      fields={[{ name: 'apikey', label: 'Enter API key' }]}
      onValidityChange={props.onValidityChange}
    />
  ),
};

export default stellareldConfig;
